import { Box, Typography, useTheme } from '@mui/material';
import { ReactNode } from 'react';
import { withAlpha } from '../indicacao.utils';

interface EmptyStateProps {
	icon: ReactNode;
	texto: string;
	acao?: ReactNode;
	destaque?: boolean;
}

export function EmptyState({ icon, texto, acao, destaque }: EmptyStateProps) {
	const theme = useTheme();
	const primary = theme.palette.primary.main;

	return (
		<Box
			display="flex"
			flexDirection="column"
			alignItems="center"
			justifyContent="center"
			gap={1.25}
			py={4}
			px={2}
			sx={{
				borderRadius: 2.5,
				border: destaque ? `1px dashed ${withAlpha(primary, 0.45)}` : '1px dashed #e2e8f0',
				bgcolor: destaque ? withAlpha(primary, 0.04) : '#f8fafc',
			}}
		>
			<Box
				sx={{
					width: 44,
					height: 44,
					borderRadius: 2.5,
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					color: destaque ? primary : 'rgb(100, 116, 139)',
					bgcolor: '#fff',
					border: destaque ? `1px solid ${withAlpha(primary, 0.28)}` : '1px solid #e2e8f0',
				}}
			>
				{icon}
			</Box>
			<Typography fontSize="0.9rem" color="text.secondary" textAlign="center">
				{texto}
			</Typography>
			{acao}
		</Box>
	);
}
